import { Component, Input } from "@angular/core";

import { BaseSearchResultsModel } from "../../../models/base-search-results.model";
import {ContentItemModel} from "../../models/content-search.model";

@Component({
    selector: "pcg-ng-content-search-results-list-view",
    templateUrl: "./content-search-results-list-view.component.html"
})
export class ContentSearchResultsListViewComponent {
    @Input() public searchResult: BaseSearchResultsModel<ContentItemModel>;
}
